export const customEn = {
  StepsTitle: 'Meet & Date Widowers Near You Today'
};
export const customEs = {
  StepsTitle: 'Conoce y sal con viudos cerca de ti hoy'
};
export const customDa = {
  StepsTitle: 'Mød og date enker nær dig i dag'
};
export const customDe = {
  StepsTitle: 'Triff und date heute Witwer in deiner Nähe'
};
export const customFi = {
  StepsTitle: 'Tapaa ja deittaile leskiä lähelläsi tänään'
};
export const customSv = {
  StepsTitle: 'Möt och dejta änklingar nära dig idag'
};
export const customFr = {
  StepsTitle: 'Rencontrez et sortez avec des veufs près de chez vous aujourd’hui'
};
export const customHu = {
  StepsTitle: 'Találkozz és randizz özvegyekkel a közeledben még ma!'
};



// WEBPACK FOOTER //
// ./src/constants/custom.localization.js